// Real client photography (DMS Wedding Films), downloaded & optimised locally
// from the provided Google Drive folder for reliability and performance.
const g = (n) => `/gallery/g${n}.jpg`;

// Per-wedding curated selections (used by the Portfolio wedding stories).
export const WEDDINGS = {
  madhuja: {
    hero: g(14),
    cover: g(11),
    gallery: [g(9), g(10), g(12), g(13), g(15), g(26), g(27), g(31), g(33), g(35), g(40), g(42)],
  },
  nittu: {
    hero: g(52),
    cover: g(85),
    gallery: [g(50), g(51), g(55), g(56), g(62), g(64), g(68), g(80), g(82), g(86), g(87)],
  },
  "rohan-ankita": {
    hero: g(92),
    cover: g(118),
    gallery: [g(89), g(90), g(94), g(98), g(100), g(103), g(104), g(114), g(116), g(120), g(121)],
  },
  seekruti: {
    hero: g(148),
    cover: g(168),
    gallery: [g(134), g(140), g(150), g(154), g(156), g(162), g(172), g(173)],
  },
  "suchika-sushovan": {
    hero: g(196),
    cover: g(219),
    gallery: [g(176), g(182), g(187), g(190), g(199), g(201), g(203), g(218), g(197)],
  },
};

// Legacy IMG structure (kept so Home/Services/Films/Testimonials/Blog keep working),
// now populated with real client photography.
export const IMG = {
  hero: [g(92), g(148), g(14), g(197), g(51)],
  aboutPortrait: g(199),
  couples: [g(11), g(89), g(150), g(196), g(199), g(203), g(120), g(52), g(176)],
  indian: [g(9), g(94), g(98), g(85), g(190), g(14), g(187)],
  details: [g(55), g(56), g(82), g(40), g(64)],
};

export const GALLERY_POOL = [...IMG.couples, ...IMG.indian, ...IMG.details];
